import { createReducer } from '../reducerUtil'
import {
  SET_IDENTITY,
  SET_LINK_INFO,
  SET_RECORDED_STATUS,
  SET_COLLECT_DATA_STEP,
  SET_NOT_AVAILABLE_INDEX,
  SET_COLLECT_MODE_ACTIVE,
  SET_GROUP_OCCUPY_STATUS,
} from './constants'

//below states are only for during collecting result, not for collected page.
const initialState = {
  collectModeActive: false, // for wheel canvas strikethrough
  identity: null,
  ownerInfo: '',
  page: '',
  path: '',
  step: 'Identity', //Identity,Pending,Submitting,Submitted,Finish,FullyClaimed
  recordedStatus: {
    name: 'initialize',
    title: '',
    description: '',
  },
  // resultCollected: null,
  // spinAgainNumber: 0,
  collectSettings: null,
  // collectDataSettings: {
  //   collectEmailChecked: true,
  //   collectNameChecked: true,
  //   oneSubmitPerEmailChecked: false,
  //   maxSubmissionValue: 7,
  //   collectActionMode: 'Done',
  //   collectSubmitResultText: false, // added in 2nd version
  // },
  notAvailableIndex: [],
  // selfJoinSettings: {
  //   collectEmailChecked: true,
  //   collectNameChecked: true,
  //   totalPeople: 10,
  // },
  groupOccupyStatus: [],
}

export const setLinkInfo = (state, payload) => {
  return {
    ...state,
    ownerInfo: payload.ownerInfo,
    page: payload.page,
    path: payload.path,
    collectSettings: payload.settings,
  }
}

export const setIdentity = (state, payload) => {
  return {
    ...state,
    identity: payload.identity,
  }
}

export const setCollectDataStep = (state, payload) => {
  return {
    ...state,
    step: payload.step,
  }
}

export const setRecordedStatus = (state, payload) => {
  return {
    ...state,
    recordedStatus: payload.recordedStatus,
  }
}

// export const setResultCollected = (state, payload) => {
//   return {
//     ...state,
//     resultCollected: payload.resultCollected,
//   }
// }

// export const setSpinAgainNumber = (state, payload) => {
//   return {
//     ...state,
//     spinAgainNumber: payload.spinAgainNumber,
//   }
// }

export const setNotAvailableIndex = (state, payload) => {
  return {
    ...state,
    notAvailableIndex: payload.array,
  }
}

export const setCollectModeActive = (state, payload) => {
  return {
    ...state,
    collectModeActive: payload.status,
  }
}
export const setGroupOccupyStatus = (state, payload) => {
  return {
    ...state,
    groupOccupyStatus: payload.status,
  }
}

export default createReducer(initialState, {
  [SET_IDENTITY]: setIdentity,
  [SET_LINK_INFO]: setLinkInfo,
  [SET_COLLECT_DATA_STEP]: setCollectDataStep,
  [SET_RECORDED_STATUS]: setRecordedStatus,
  [SET_NOT_AVAILABLE_INDEX]: setNotAvailableIndex,
  [SET_COLLECT_MODE_ACTIVE]: setCollectModeActive,
  [SET_GROUP_OCCUPY_STATUS]: setGroupOccupyStatus,
})
